import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Container from "../../../common/Container";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import teraco from "../../../assets/images/teraco.jpg";

const Teraco = () => {
  return (
    <Box bgcolor={"#fff"}>
      <Helmet>
        <title>
          {" "}
          Use Case for Digital Infrastructure and Data Center Solutions
        </title>
      </Helmet>
      <AppBar
        position={"sticky"}
        elevation={0}
        sx={{
          backgroundColor: "#fff",
          padding: "10px 0px",
        }}
      >
        <Container paddingY={{ xs: 1 / 2, sm: 1 }}>
          <Header />
        </Container>
      </AppBar>
      <Container bgcolor={"#fff"}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"flex-start"}
          flexWrap={"wrap"}
        >
          <Box
            width={{ xs: "100%", sm: "80%" }}
            padding={{ xs: "25% 0% 10% 0%", sm: "2% 0%" }}
            marginLeft={{ xs: "0%", sm: "0%" }}
          >
            <Box display={"flex"} alignItems={"center"} marginBottom={"2%"}>
              <Box
                component="img"
                height={{ xs: "28vh", sm: "550px" }}
                width={{ xs: "100%", sm: "100%" }}
                marginTop={{ xs: "20%", sm: "0%" }}
                src={teraco}
                alt={"teraco_img"}
                sx={{
                  objectFit: "cover",
                  borderRadius: "30px",
                }}
              />
            </Box>
            <Typography
              variant="h4"
              color={"#39484E"}
              fontWeight={700}
              paddingBottom={{ xs: "2%", sm: "1%" }}
              textAlign={"left"}
            >
              CASE 2: Teraco Data Environments
            </Typography>
            <Typography
              variant="h6"
              color={"#4f4f4f"}
              fontWeight={700}
              paddingBottom={{ xs: "5%", sm: "2%" }}
              textAlign={"left"}
            >
              Use Case for Digital Infrastructure and Data Center Solutions
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              Teraco Data Environments is Africa’s largest provider of
              carrier-neutral colocation and interconnection services. Teraco
              offers a critical infrastructure platform for improving digital
              connectivity and fostering data-driven solutions in Africa.
              Teraco’s ecosystem supports over 22,000 interconnections,
              facilitating seamless collaboration among businesses, service
              providers, and government entities. This infrastructure is
              critical for scaling AI-driven solutions to challenges in
              agriculture, healthcare, and education. For example, Teraco’s
              colocation facilities enable rapid data processing and storage,
              which are essential for predictive modeling in climate-resilient
              farming and public health interventions.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              Investing in infrastructure platforms like Teraco Data
              Environments offers transformative opportunities for local African
              economies, particularly in secondary cities. These platforms
              provide the foundational digital infrastructure needed for
              enhanced connectivity and the adoption of data-driven solutions
              that address systemic challenges. With faster data processing and
              more reliable interconnections, infrastructure platforms can drive
              economic growth, improve market access, and foster innovation in
              underserved regions.
            </Typography>
          </Box>
        </Box>
      </Container>
      <Box bgcolor={"#213555"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Teraco;
